import Header from '../layout/Header';
import Footer from '../layout/Footer';
import {blogArticles} from '../../config/blogArticles';

function formatDate(dateStr) {
    const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];
    const d = new Date(dateStr);
    return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
}

export default function BlogListPage() {
    return (
        <div className="min-h-screen bg-white font-sans flex flex-col">
            <Header onHomeClick={() => window.location.href = '/'}/>

            <main className="flex-1 w-full max-w-[800px] mx-auto px-4 py-8">
                <nav className="text-sm text-brand-dark/50 mb-6">
                    <a href="/" className="hover:text-brand-red transition">Главная</a>
                    <span className="mx-2">/</span>
                    <span className="text-brand-dark">Блог</span>
                </nav>

                <h1 className="text-3xl md:text-4xl font-bold text-brand-dark mb-8">Блог</h1>

                <div className="flex flex-col gap-8">
                    {blogArticles.map(article => (
                        <a
                            key={article.slug}
                            href={`/blog/${article.slug}/`}
                            className="block group rounded-2xl border border-brand-dark/10 p-6 hover:border-brand-red/30 hover:shadow-lg transition"
                        >
                            <time className="text-sm text-brand-dark/40">{formatDate(article.date)}</time>
                            <h2 className="text-xl md:text-2xl font-bold text-brand-dark mt-2 mb-3 group-hover:text-brand-red transition">
                                {article.title}
                            </h2>
                            <p className="text-brand-dark/70 leading-relaxed">{article.excerpt}</p>
                            <span className="inline-block mt-4 text-sm font-medium text-brand-red">
                                Читать далее →
                            </span>
                        </a>
                    ))}
                </div>
            </main>

            <Footer/>
        </div>
    );
}
